export default __webpack_public_path__ + "static/media/licencia.861e7fb0.svg";